import React, {useState, useEffect} from 'react';
import {useHttp} from "../../../hooks/use-http";
import styled from "styled-components";

const StyledNewsArchivesBlock = styled.div`
    margin-bottom: 25px;
    & h5 {
        margin: 0 0 15px;
        font-family: "Roboto Slab", serif;
        font-weight: 700;
        font-size: 1.5rem;
        color: #2a5934;
    }
    & ul {
        list-style-type: none;
        padding: 0;
        margin-left: 10px;
        & li {
            padding: 0;
            cursor: pointer;
        }
        & li:before {
            box-sizing: border-box;
            content: ">";
            color: #38a935;
            margin-right: 10px;
        }
        & li a {
            color: #2a5934 !important;
            text-decoration: none;
        }
        & li a:hover {
            color: #38a935 !important;
        }
    }  
`;

export const NewsArchivesBlock = () => {

    const [archiveLinks, setArchiveLinks] = useState([])
    const {error, isLoading, sendRequest: getContent} = useHttp();

    useEffect(() => {
        const transformResponse = (data) => {
            setArchiveLinks(data.payload?.control ? data.payload.control : []);
        };
        const fetchArchives = () => {
            getContent({url: '/news/archives/list'}, transformResponse);
        };

        fetchArchives();
    }, [getContent]);
    
    return (
        <StyledNewsArchivesBlock>
          <h5>News Archives</h5>
            <ul>
                {isLoading && <li>Loading...</li>}
                {error && <li>{error}</li>}
                {archiveLinks.map((item) => {
                    return <li key={item.key}> <a href={`/news/list/f/date/${item.key}`}>{item.label}</a></li>;
                })}
                <li><a href="/news/list"> All News</a></li>
            </ul>
        </StyledNewsArchivesBlock>
    );
};
